/* fo.js — Fish-oil landing page behaviour. No dependencies. Loaded by layout/lp-fishoil.liquid (defer). */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Hero carousel ---------- */
  (function carousel() {
    var fig = $('[data-fo-carousel]'); if (!fig) return;
    var c = $('#fo-car', fig), dots = $('#fo-dots', fig), n = c.children.length, i = 0, t;
    if (!n) return;
    for (var k = 0; k < n; k++) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (k + 1));
      (function (k) { b.onclick = function () { go(k, true); }; })(k); dots.appendChild(b);
    }
    function go(k, user) { i = (k + n) % n; c.scrollTo({ left: c.clientWidth * i, behavior: 'smooth' }); paint(); if (user) stop(); }
    function paint() {
      $$('button', dots).forEach(function (b, k) { b.classList.toggle('fo-on', k === i); });
      fig.classList.toggle('fo-designed', c.children[i].classList.contains('fo-slide'));
    }
    c.addEventListener('scroll', function () { var k = Math.round(c.scrollLeft / c.clientWidth); if (k !== i) { i = k; paint(); } }, { passive: true });
    $('.fo-arr-l', fig).onclick = function () { go(i - 1, true); };
    $('.fo-arr-r', fig).onclick = function () { go(i + 1, true); };
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function start() { if (!rm) t = setInterval(function () { go(i + 1); }, 5000); }
    function stop() { clearInterval(t); }
    c.addEventListener('touchstart', stop, { passive: true }); fig.addEventListener('mouseenter', stop); fig.addEventListener('mouseleave', start);
    paint(); start();
  })();

  /* ---------- Buy block (one-time, two sizes) ---------- */
  (function buy() {
    var cfgEl = $('#fo-config'); if (!cfgEl) return;
    var CFG; try { CFG = JSON.parse(cfgEl.textContent.replace(/,(\s*[\]}])/g, '$1')); } catch (e) { if (window.console) console.error('fo-buy: config JSON invalid', e); return; }
    var P = CFG.products || {}, BANDS = CFG.bands || [];
    if (!BANDS.length || !P.jug) return;
    var onTile = $('#fo-bands .fo-on');
    var band = Math.min(onTile ? (parseInt(onTile.dataset.band, 10) || 0) : 0, BANDS.length - 1), offer = 'jug';

    function money(cents) {
      var n = (cents / 100).toFixed(2), f = CFG.moneyFormat || '${{amount}}';
      return f.replace(/<[^>]+>/g, '').replace(/\{\{\s*amount[^}]*\}\}/, n);
    }
    // Days of supply → plain-English span. Capped at "a year": the label says use within 1 year of opening.
    function supply(d) {
      if (d < 56) return Math.round(d / 7) + ' Weeks';
      var m = d / 30.4;
      if (m >= 11.5) return 'a Year';
      return Math.round(m) + ' Months';
    }
    function lc(s) { return s.replace(/^a Year$/, 'a year').replace(/(\d+) (Weeks|Months)/, function (_, n, u) { return n + ' ' + u.toLowerCase(); }); }
    function fill(tpl, v) { return (tpl || '').replace(/\{(\w+)\}/g, function (_, k) { return v[k] != null ? v[k] : ''; }); }
    function set(id, txt) { var el = $('#' + id); if (el) el.textContent = txt; }
    function perDay(c) { return c >= 100 ? money(c) + ' a day' : c + '¢ a day'; }

    function calc(key) {
      var pr = P[key], ml = BANDS[band].ml, days = pr.cap / ml;
      var flat = Math.round((CFG.flatShip || 0) * 100), freeAt = Math.round((CFG.freeAt || 0) * 100);
      var ship = (key === 'jug' && CFG.jugFreeShip) ? 0 : (pr.price < freeAt ? flat : 0);
      return { pr: pr, days: days, ship: ship, landed: pr.price + ship, cpd: Math.round((pr.price + ship) / days) };
    }

    function render() {
      var b = BANDS[band], j = calc('jug'), t = calc('trial');
      set('fo-dose', b.tsp + ' a day, once daily — the label dose for ' + b.who + '.');
      set('fo-jugdesc', 'About ' + lc(supply(j.days)) + ' for ' + b.who);
      set('fo-jugprice', money(j.pr.price));
      var bottles = Math.round(j.pr.cap / t.pr.cap), was = bottles * t.pr.price, pct = Math.round((1 - j.pr.price / was) * 100);
      var wasEl = $('#fo-jugwas'); if (wasEl) { wasEl.textContent = CFG.jugCompare && was > j.pr.price ? money(was) : ''; wasEl.title = bottles + ' × 16oz bottles'; }
      set('fo-jugrib', fill(CFG.jugRibbon, { pct: pct + '%' }));
      var fishOz = parseFloat(CFG.fishPerOz) || 0, vs = $('#fo-jugvs');
      if (vs) { if (fishOz > 0) { var fishDay = Math.round(fishOz * 100 * (b.ml / 29.5735)); vs.textContent = fill(CFG.jugVsLine, { tsp: b.tsp, fishday: perDay(fishDay).replace(' a day', ''), ratio: (fishDay / Math.max(j.cpd, 1)).toFixed(1) + '×' }); } else { vs.textContent = ''; } }
      set('fo-jugship', j.ship ? '+ ' + money(j.ship) + ' shipping' : fill(CFG.jugShipChip || 'Free shipping', { save: money(Math.round((CFG.flatShip || 0) * 100)).replace(/\.00\b/, '') }));
      set('fo-jugday', '~' + perDay(j.cpd));
      set('fo-trialprice', money(t.pr.price));
      set('fo-trialship', t.ship ? '+ ' + money(t.ship) + ' shipping' : 'Ships free');
      var cur = offer === 'jug' ? j : t;
      var vars = { supply: supply(cur.days), price: money(cur.pr.price), landed: money(cur.landed), ship: money(cur.ship) };
      var cta = fill(offer === 'jug' ? CFG.ctaJug : CFG.ctaTrial, vars), perch = offer === 'jug' ? CFG.perchJug : CFG.perchTrial;
      set('fo-ctatext', cta); set('fo-stickytext', cta); set('fo-ctaperch', perch || ''); set('fo-stickyp', perch || '');
      $$('#fo-cta, #fo-stickycta').forEach(function (a) { a.href = cur.pr.href; });
      var mi = $('#fo-mainimg'); if (mi && cur.pr.img) { mi.src = cur.pr.img; mi.removeAttribute('srcset'); mi.classList.remove('fo-contain'); }
      $$('.fo-thumbs div').forEach(function (x) { x.classList.remove('fo-on'); });
    }

    $$('[data-band]').forEach(function (x) { x.addEventListener('click', function () { band = +x.dataset.band; $$('[data-band]').forEach(function (y) { var on = y === x; y.classList.toggle('fo-on', on); y.setAttribute('aria-checked', on); }); render(); }); });
    $$('.fo-offer').forEach(function (o) {
      var input = $('input', o);
      function pick() { offer = o.dataset.offer; $$('.fo-offer').forEach(function (x) { x.classList.toggle('fo-on', x === o); }); if (input) input.checked = true; render(); }
      o.addEventListener('click', pick); if (input) input.addEventListener('change', pick);
    });
    $$('.fo-thumbs div').forEach(function (t) {
      t.addEventListener('click', function () {
        var im = $('img', t), mi = $('#fo-mainimg');
        if (im && mi) { mi.src = im.currentSrc || im.src; mi.removeAttribute('srcset'); mi.classList.toggle('fo-contain', t.classList.contains('fo-contain')); }
        $$('.fo-thumbs div').forEach(function (x) { x.classList.toggle('fo-on', x === t); });
      });
    });
    render();

    /* sticky bar (mobile) */
    var st = $('#fo-sticky'), hero = $('#fo-hero'), buyEl = $('#fo-buy');
    function onS() {
      if (!st) return;
      var past = hero ? window.scrollY > hero.offsetTop + hero.offsetHeight - 80 : window.scrollY > 600;
      var inBuy = buyEl ? (window.scrollY + window.innerHeight > buyEl.offsetTop + 200 && window.scrollY < buyEl.offsetTop + buyEl.offsetHeight - 300) : false;
      st.classList.toggle('fo-show', window.innerWidth <= 860 && past && !inBuy);
    }
    window.addEventListener('scroll', onS, { passive: true }); window.addEventListener('resize', onS); onS();
    // Shopify's theme-preview bar is also fixed to the bottom of the viewport: lift the sticky bar above it (preview only).
    function liftForPreviewBar() { var pb = document.getElementById('PBarNextFrameWrapper'); if (st && pb) { st.style.bottom = (pb.getBoundingClientRect().height || 56) + 'px'; } }
    liftForPreviewBar(); setTimeout(liftForPreviewBar, 1500); setTimeout(liftForPreviewBar, 4000);
  })();
})();

/* ---------- Comparison table: mobile column toggle ---------- */
(function compare() {
  var tbl = document.getElementById('fo-compare-tbl'), btns = Array.prototype.slice.call(document.querySelectorAll('.fo-compare-toggle button'));
  if (!tbl || !btns.length) return;
  btns.forEach(function (b) { b.addEventListener('click', function () {
    tbl.classList.toggle('fo-show-a', b.dataset.show === 'a'); tbl.classList.toggle('fo-show-b', b.dataset.show === 'b');
    btns.forEach(function (x) { var on = x === b; x.classList.toggle('fo-on', on); x.setAttribute('aria-selected', on); });
  }); });
})();

/* ---------- Video testimonials: click-to-play, pause the others ---------- */
(function videos() {
  var figs = Array.prototype.slice.call(document.querySelectorAll('.fo-video'));
  if (!figs.length) return;
  figs.forEach(function (f) {
    var v = f.querySelector('video'), btn = f.querySelector('.fo-play');
    if (!v) return;
    v.removeAttribute('autoplay'); v.removeAttribute('controls'); v.muted = false; v.setAttribute('playsinline', '');
    function play() { figs.forEach(function (o) { var ov = o.querySelector('video'); if (ov && ov !== v) { ov.pause(); o.classList.remove('fo-playing'); } }); v.setAttribute('controls', ''); v.play(); f.classList.add('fo-playing'); }
    if (btn) btn.addEventListener('click', play);
    v.addEventListener('play', function () { f.classList.add('fo-playing'); });
    v.addEventListener('pause', function () { if (v.currentTime === 0 || v.ended) f.classList.remove('fo-playing'); });
    v.addEventListener('ended', function () { f.classList.remove('fo-playing'); });
  });
})();
